import type { Mouvement } from '@mairistem/comptabilite';
import { UserRole } from '@mairistem/finances-utils';
import BordereauStateStep from '../../../constants/liquidation/bordereaux/BordereauStateStep';
import BordereauStateType from '../../../constants/liquidation/bordereaux/BordereauStateType';
import type BordereauActionType from '../../../interfaces/pieces/bordereaux/BordereauActionType';
import type MouvementActionType from '../../../interfaces/pieces/mouvements/liquidation/MouvementActionType';
import type { BordereauWithState } from '../../../interfaces/pieces/TreeRow';
import MouvementDupliquerAction from '../../mouvements/liquidation/actions/MouvementDupliquerAction';
import MouvementModifierAction from '../../mouvements/liquidation/actions/MouvementModifierAction';
import type BaseLiquidationAction from '../../pieces/BaseLiquidationAction';
import BordereauAnnulerAction from '../actions/BordereauAnnulerAction';
import BordereauDupliquerAction from '../actions/BordereauDupliquerAction';
import BordereauForceEtatAcquittementAction from '../actions/BordereauForceEtatAcquittementAction';
import BordereauModifierAction from '../actions/BordereauModifierAction';
import BordereauRelancerFlux360Action from '../actions/BordereauRelancerFlux360Action';
import BordereauRelancerFluxAction from '../actions/BordereauRelancerFluxAction';
import BaseBordereauState from './BaseBordereauState';

class BordereauFluxEmisState extends BaseBordereauState {
	constructor() {
		super();
		this.step = BordereauStateStep.FLUX_EMIS;
		this.state = BordereauStateType.FLUX_EMIS;
		this.color = '#757575';
		this.libelle = 'Flux émis';
	}

	getBordereauActions(
		_bordereau: BordereauWithState,
		userRole: UserRole,
	): BaseLiquidationAction<BordereauWithState, BordereauActionType>[] {
		return [
			new BordereauRelancerFluxAction({ isActionPrincipale: true }),
			new BordereauRelancerFlux360Action(),
			new BordereauForceEtatAcquittementAction({ isAcquittement: true }),
			new BordereauForceEtatAcquittementAction({ isAcquittement: false }),
			new BordereauDupliquerAction(),
			new BordereauAnnulerAction(),
			...(userRole === UserRole.ADMIN
				? [new BordereauModifierAction({ isSuperUser: true })]
				: []),
		];
	}

	getMouvementActions(
		userRole: UserRole,
	): BaseLiquidationAction<Mouvement, MouvementActionType>[] {
		return [
			new MouvementModifierAction({ isReadonly: true }),
			new MouvementDupliquerAction(),
			...this.getActionsAnnulationRejet(),
			...(userRole === UserRole.ADMIN
				? [new MouvementModifierAction({ isSuperUser: true })]
				: []),
		];
	}
}

export default BordereauFluxEmisState;
